export default "__VITE_ASSET__Dp3rNvGK__"